import React from 'react';
import ProjectCard from './ProjectCard';

const ProjectsList = ({ projects, lang }) => {
  return (
    <div className="projects__content">
      {projects.map((project, index) => (
        <ProjectCard key={index} project={project} lang={lang} />
      ))}
    </div>
  );
};

export default ProjectsList;